/**
 * Keterangan "terakhir tercatat" untuk pemilih kurir — MURNI.
 *
 * ATURAN YANG TIDAK BOLEH DILANGGAR: umur SELALU ikut ditampilkan.
 *
 * Posisi tanpa keterangan umur terbaca sebagai posisi SEKARANG. Ia akan membuat manajer
 * memberangkatkan kurir berdasarkan titik lima jam lalu tanpa tahu itu lima jam lalu — persis
 * kelas kegagalan yang berulang sepanjang 26–27 Agustus 2026: angka yang terlihat benar padahal
 * basi. Sistem ini TIDAK melacak posisi terus-menerus (ADR-0036 §D1), jadi setiap titik memang
 * berumur, dan umurnya adalah bagian dari kebenarannya.
 */

export interface TerakhirTerlihat {
  readonly userId: string;
  readonly occurredAt: string;
  readonly sumber: 'absen' | 'tugas';
  readonly lokasi: string | null;
}

/** Umur dalam kalimat pendek. Kasar dengan sengaja — yang dibutuhkan urutan besarannya. */
export function umurSingkat(occurredAt: string, sekarang: Date): string {
  const menit = Math.floor((sekarang.getTime() - new Date(occurredAt).getTime()) / 60_000);
  /*
   * `< 2` sekaligus menangkap waktu di MASA DEPAN (menit negatif), yang terjadi bila jam
   * perangkat meleset. Tidak ada penjaga negatif terpisah: baris yang tampak menjaga padahal
   * cabangnya tak pernah tercapai membuat sabotase berbunyi hijau dan menipu pembacanya —
   * terbukti saat penjaga itu dicabut dan tidak satu pun uji menyala.
   */
  if (menit < 2) return 'baru saja';
  if (menit < 60) return `${menit} mnt lalu`;
  const jam = Math.floor(menit / 60);
  if (jam < 24) return `${jam} jam lalu`;
  return `${Math.floor(jam / 24)} hari lalu`;
}

/**
 * Baris keterangan di bawah nama kurir.
 *
 * Tanpa data sama sekali dikatakan apa adanya — BUKAN dikosongkan. Baris kosong terbaca seperti
 * "tidak ada yang perlu diperhatikan", padahal artinya "kita tidak tahu".
 */
export function keteranganTerakhir(data: TerakhirTerlihat | undefined, sekarang: Date): string {
  if (!data) return 'Belum ada catatan lokasi';
  const tempat = data.lokasi ?? 'di luar lokasi kerja';
  return `${tempat} · ${umurSingkat(data.occurredAt, sekarang)}`;
}

/** Peta userId → keterangan, supaya pemanggil tidak mencari-cari di dalam render. */
export function petaTerakhir(
  daftar: readonly TerakhirTerlihat[],
): ReadonlyMap<string, TerakhirTerlihat> {
  return new Map(daftar.map((d) => [d.userId, d]));
}
